/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_DE_DE: Record<string, string> = {
    ariaAnnounceChart: 'Diagramm, ${seriesCount}[number] Reihen',
    ariaAnnounceFlowProportionLink: 'Link ${index} von ${count}, von ${from} bis ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'Knoten ${index} von ${count}, ${description}',
    ariaAnnounceGaugeChart: 'Tachometerdiagramm, ${caption}',
    ariaAnnounceHierarchyChart: 'Hierarchiediagramm, ${caption}',
    ariaAnnounceHierarchyDatum: 'Ebene ${level}[number], ${count}[number] Kinder, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Drücken Sie die Leertaste oder die Eingabetaste, um die Sichtbarkeit umzuschalten',
    ariaLabelAddHorizontalLine: 'Horizontale Linie hinzufügen',
    ariaLabelAnnotationOptionsToolbar: 'Anmerkungsoptionen',
    ariaLabelAnnotationSettingsDialog: 'Annotationseinstellungen',
    ariaLabelColorPicker: 'Farbwähler',
    ariaLabelFinancialCharts: 'Finanzdiagramme',
    ariaLabelLegend: 'Legende',
    ariaLabelLegendItem: '${label}, Legendenpunkt ${index}[number] von ${count}[number]',
    ariaLabelLegendItemUnknown: 'Unbekanntes Legenden Element',
    ariaLabelLegendPageNext: 'Nächste Legenden-Seite',
    ariaLabelLegendPagePrevious: 'Vorherige Legenden-Seite',
    ariaLabelLegendPagination: 'Legenden-Seitenumbruch',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Mindestwert',
    ariaLabelNavigatorRange: 'Bereich',
    ariaLabelRangesToolbar: 'Bereiche',
    ariaLabelSettingsTabBar: 'Einstellungen',
    ariaLabelZoomToolbar: 'Vergrößern',
    ariaValuePanRange: '${min}[percent0to2dp] bis ${max}[percent0to2dp]',
    contextMenuDownload: 'Herunterladen',
    contextMenuPanToCursor: 'Hierher schwenken',
    contextMenuToggleOtherSeries: 'Andere Serien umschalten',
    contextMenuToggleSeriesVisibility: 'Sichtbarkeit umschalten',
    contextMenuZoomToCursor: 'Hierher zoomen',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Datum und Preis',
    dialogHeaderDateRange: 'Datumsbereich',
    dialogHeaderFibonacciRange: 'Fib Rücksetzung',
    dialogHeaderLine: 'Linie',
    dialogHeaderPriceRange: 'Preisspanne',
    dialogHeaderText: 'Text',
    dialogInputAlign: 'Ausrichten',
    dialogInputColorPicker: 'Farbe',
    dialogInputColorPickerAltText: 'Textfarbe',
    dialogInputExtendAbove: 'Nach oben erweitern',
    dialogInputExtendBelow: 'Nach unten erweitern',
    dialogInputExtendChannelEnd: 'Kanalende erweitern',
    dialogInputExtendChannelStart: 'Kanalanfang erweitern',
    dialogInputExtendLeft: 'Nach links erweitern',
    dialogInputExtendLineEnd: 'Linienende verlängern',
    dialogInputExtendLineStart: 'Linienanfang verlängern',
    dialogInputExtendRight: 'Nach rechts verlängern',
    dialogInputFibonacciBands: 'Bänder',
    dialogInputFibonacciBandsAltText: 'Fibonacci-Bänder',
    dialogInputFillColorPicker: 'Füllen',
    dialogInputFillColorPickerAltText: 'Füllfarbe',
    dialogInputFontSize: 'Größe',
    dialogInputFontSizeAltText: 'Schriftgröße',
    dialogInputLineStyle: 'Gestrichelt',
    dialogInputPosition: 'Position',
    dialogInputReverse: 'Umkehren',
    dialogInputShowFill: 'Füllung anzeigen',
    dialogInputStrokeWidth: 'Linienbreite',
    dialogInputStrokeWidthAltText: 'Linienstärke',
    iconAltTextAlignCenter: 'Zentrum',
    iconAltTextAlignLeft: 'Links',
    iconAltTextAlignRight: 'Rechts',
    iconAltTextClose: 'Schließen',
    iconAltTextLineStyleDashed: 'Lang gestrichelt',
    iconAltTextLineStyleDotted: 'Kurz gestrichelt',
    iconAltTextLineStyleSolid: 'Durchgezogen',
    iconAltTextPositionBottom: 'Unten',
    iconAltTextPositionCenter: 'Mitte',
    iconAltTextPositionTop: 'Oben',
    inputTextareaPlaceholder: 'Text hinzufügen',
    measurerDateRangeBars: '${value}[number] Balken',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Volumen ${value}',
    overlayLoadingData: 'Daten werden geladen...',
    overlayNoData: 'Keine Daten zum Anzeigen',
    overlayNoVisibleSeries: 'Keine sichtbaren Serien',
    overlayUnsupportedBrowser: 'Inkompatible Browserversion. Bitte aktualisieren Sie Ihren Browser.',
    seriesHistogramTooltipCount: '${yName} (Anzahl)',
    seriesHistogramTooltipFrequency: 'Häufigkeit',
    seriesHistogramTooltipMean: '${yName} (Mittelwert)',
    seriesHistogramTooltipSum: '${yName} (Summe)',
    toolbarAnnotationsArrow: 'Pfeil',
    toolbarAnnotationsArrowDown: 'Pfeil nach unten',
    toolbarAnnotationsArrowUp: 'Pfeil nach oben',
    toolbarAnnotationsCallout: 'Hinweis',
    toolbarAnnotationsClearAll: 'Alles löschen',
    toolbarAnnotationsComment: 'Kommentar',
    toolbarAnnotationsDatePriceRange: 'Datum und Preis',
    toolbarAnnotationsDateRange: 'Datumsbereich',
    toolbarAnnotationsDelete: 'Löschen',
    toolbarAnnotationsDisjointChannel: 'Getrennter Kanal',
    toolbarAnnotationsDragHandle: 'Werkzeugleiste ziehen',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib-Retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib retracement basierend auf Trend',
    toolbarAnnotationsFillColor: 'Füllfarbe',
    toolbarAnnotationsHorizontalLine: 'Horizontale Linie',
    toolbarAnnotationsLineAnnotations: 'Trendlinien',
    toolbarAnnotationsLineColor: 'Linienfarbe',
    toolbarAnnotationsLineStrokeWidth: 'Linienstrichbreite',
    toolbarAnnotationsLineStyle: 'Linienstil',
    toolbarAnnotationsLock: 'Sperren',
    toolbarAnnotationsMeasurerAnnotations: 'Messgeräte',
    toolbarAnnotationsNote: 'Hinweis',
    toolbarAnnotationsParallelChannel: 'Paralleler Kanal',
    toolbarAnnotationsPriceRange: 'Preisspanne',
    toolbarAnnotationsQuickDatePriceRange: 'Messen',
    toolbarAnnotationsSettings: 'Einstellungen',
    toolbarAnnotationsShapeAnnotations: 'Pfeile',
    toolbarAnnotationsText: 'Text',
    toolbarAnnotationsTextAnnotations: 'Textanmerkungen',
    toolbarAnnotationsTextColor: 'Textfarbe',
    toolbarAnnotationsTextSize: 'Textgröße',
    toolbarAnnotationsTrendLine: 'Trendlinie',
    toolbarAnnotationsUnlock: 'Freischalten',
    toolbarAnnotationsVerticalLine: 'Vertikale Linie',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 Monat',
    toolbarRange1Year: '1J',
    toolbarRange1YearAria: '1 Jahr',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 Monate',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 Monate',
    toolbarRangeAll: 'Alle',
    toolbarRangeAllAria: 'Alle',
    toolbarRangeYearToDate: 'Seit Jahresbeginn',
    toolbarRangeYearToDateAria: 'Jahr bis Datum',
    toolbarSeriesTypeCandles: 'Kerzen',
    toolbarSeriesTypeDropdown: 'Diagrammtyp',
    toolbarSeriesTypeHighLow: 'Hoch Tief',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Hohle Kerzen',
    toolbarSeriesTypeLine: 'Linie',
    toolbarSeriesTypeLineWithMarkers: 'Linie mit Markierungen',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Stufenlinie',
    toolbarZoomPanEnd: 'Zum Ende verschieben',
    toolbarZoomPanLeft: 'Nach links verschieben',
    toolbarZoomPanRight: 'Nach rechts schwenken',
    toolbarZoomPanStart: 'Zum Anfang schwenken',
    toolbarZoomReset: 'Zoom zurücksetzen',
    toolbarZoomZoomIn: 'Vergrößern',
    toolbarZoomZoomOut: 'Verkleinern',
    tooltipPaginationStatus: '${index}[number] von ${count}[number]',
};
